<div class="stepper-wrapper">
	@for(item of [].constructor(totalStep()); track item; let index = $index;)
	{
	<div class="stepper-item" [ngClass]="{'active':(currentStep()===(index+1)),'completed':(index+1<currentStep())}">
		<div class="step-counter">{{displayNumbers()?index:''}}</div>
	</div>
	}
</div>